/**
 * Review & send: validate → persist draft lines → email. Never send on a failed check.
 * Submitted/paid: skip persist and never attach lines[] to the email body.
 */
import { buildLinesSavePayload, lineExceeds100, overbillLineMessage, toEditableLine, type G703DraftSlice, type G703EditableLine } from './g703GridLogic'
import { isPayAppLockedForLineEdits } from './coLabel'
import type { PayAppLine } from '../api/types'

export function editableLinesFromDetail(
  lines: PayAppLine[] | undefined,
  draft?: G703DraftSlice[],
): G703EditableLine[] {
  const draftMap = new Map((draft ?? []).map(d => [d.id, d]))
  return (lines ?? []).map(l => toEditableLine(l, draftMap.get(l.id)))
}

export function firstOverbilledLine(lines: G703EditableLine[]): G703EditableLine | null {
  return lines.find(lineExceeds100) ?? null
}

export async function persistThenEmailPayApp(opts: {
  payAppId: number
  emailTo: string
  lines: G703EditableLine[]
  status?: string | null
  persist: (payAppId: number, body: { lines: ReturnType<typeof buildLinesSavePayload> }) => Promise<unknown>
  email: (payAppId: number, data: {
    to_email: string
    lines?: ReturnType<typeof buildLinesSavePayload>
  }) => Promise<unknown>
}): Promise<void> {
  const bad = firstOverbilledLine(opts.lines)
  if (bad) throw new Error(overbillLineMessage(bad))
  const locked = isPayAppLockedForLineEdits(opts.status)
  const payload = buildLinesSavePayload(opts.lines)
  if (!locked) {
    await opts.persist(opts.payAppId, { lines: payload })
  }
  await opts.email(opts.payAppId, {
    to_email: opts.emailTo,
    ...(locked ? {} : { lines: payload }),
  })
}
